import { deleteOrderLine, useDeleteEntrance } from "@app/store/actions/orderActions"
import { useGetStrings, useGetZone } from "@app/store/service/cmsService"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { getDateString } from "@app/utils/localeUtils"
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, ButtonStyle, Variant } from "@tecreation/funnel-components"
import OrderLine from "../OrderLine/OrderLine"
import OrderLines from "../OrderLines/OrderLines"

export default function Entrance({ date, orderLines, onAction, deletable, zoneId }) {
	const deleteEntrance = useDeleteEntrance()

	const { data: zone } = useGetZone(zoneId, { defaultData: {} })

	const { data: stringData } = useGetStrings()
	const { atThe, delivery, buttonLabelRemoveEntranceTickets, yourTicketsLabel } = stringData || {}
	return (
		<div className="color-bg-secondary-100 mb-3">
			<div className="p-3 f4">
				<div className="flex flex-justify-between flex-items-start">
					<div className="regular">
						{zone.title} {atThe} {getDateString(date)}
					</div>
					{deletable && (
						<Button
							style={ButtonStyle.icon}
							onClick={() => {
								deleteEntrance(date, zoneId)
								onAction()
							}}
							variant={Variant.primary}
							ariaLabel={buttonLabelRemoveEntranceTickets}
						>
							<FontAwesomeIcon icon={faTrash} />
						</Button>
					)}
				</div>

				<div>
					<div className="f5">
						<span>
							{delivery}:{" "}
							<span style={{ fontStyle: "italic" }} className="color-fg-secondary">
								{orderLines[0].transporter}
							</span>{" "}
						</span>
					</div>
				</div>
			</div>

			<OrderLines ariaLabel={yourTicketsLabel}>
				{orderLines.map(orderLine => (
					<OrderLine
						key={orderLine.orderLineId}
						orderLine={orderLine}
						isEditable={orderLine.details[0].typeId === ORDER_LINE_TYPES.Activity}
						showMinus={orderLine.details[0].typeId === ORDER_LINE_TYPES.Activity}
						showPlus={false}
						onMinus={() => {
							if (orderLine.details[0].typeId === ORDER_LINE_TYPES.Activity) {
								deleteOrderLine(orderLine)
								onAction()
							}
						}}
					/>
				))}
			</OrderLines>
		</div>
	)
}
